import React, {useContext} from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { UserContext } from '../hooks/UserContext';
import useLogout from './../hooks/useLogout';

// images
import logo from "../images/logo-v2.png";

// styles
import "./Header.scss";



const Header = () => {

    let { user } = useContext(UserContext);
    const { logoutUser } = useLogout(); 


    return (
        <div id="header" className="animate-fadeDown">
            <Container>
                <Navbar expand="lg">
                    <Navbar.Brand href="/">
                        <img
                            src={logo}
                            alt="logo"
                            className="img-fluid"
                            style={{ maxHeight: 150 }}
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle
                        aria-controls="navbarsDefault"
                        className="hidden-sm-up"
                    />
                    <Navbar.Collapse id="navbarsDefault">
                        <Nav className="ms-auto" as="ul" defaultActiveKey="/">
                            <Nav.Item as="li">
                                <i className="fas fa-home me-1"></i>
                                <Nav.Link href="/" className="nav-link">
                                    <p>Home</p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <i className="fas fa-comments me-1"></i>
                                <Nav.Link href="/contact">
                                    <p>Talk to me</p>
                                </Nav.Link>
                            </Nav.Item>
                            {user && user.role === "admin" && (
                                <Nav.Item as="li">
                                    <i className="fas fa-user-shield me-1"></i>
                                    <Nav.Link href="/admin">
                                        <p>Admin</p>
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            {user && (
                                <Nav.Item as="li">
                                    <i className="fas fa-sign-out-alt"></i>
                                    <Nav.Link onClick={logoutUser}>
                                        <p>Sign out</p>
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        </div>
    );
};

export default Header;
